<div class="stip-option">
	<label for="stip-{{stip.stipId}}">
		<input type="checkbox"
					 name="stip-{{stip.stipId}}"
					 id="stip-{{stip.stipId}}"
					 [checked]="checked"
					 (change)="onValueChange($event)"
					 [disabled]="disabled">
		<h5 class="title">Stip {{index}}</h5>
		<p class="text" [innerHTML]="stip.stipulation | safeHtml"></p>
	</label>
</div>
